<div class="dialog-header">
  <h3 matDialogTitle>Assign Meter</h3>
  <button
    class="close-button"
    mat-icon-button
    tabindex="-1"
    id="closeModalbtn"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <div class="row">
    <div class="form">
      <form
        [formGroup]="formdata"
        #formDirective="ngForm"
        style="width: 95%"
        novalidate
      >
        <mat-form-field>
          <input
            matInput
            type="text"
            #meterSearch
            formControlName="inputSearchCtr"
            placeholder="Search..."
            [(ngModel)]="searchMtrToAssign"
            style="width: 100%"
            title="Search the Meter"
          />
        </mat-form-field>
        <mat-selection-list
          #meters
          formControlName="assignMtrCtr"
          class="meterstyle"
        >
          <mat-option style="font-size: 16px"> Please Select Meter </mat-option>
          <mat-list-option
            *ngFor="
              let option of availableMeters | meterIdFilter : searchMtrToAssign
            "
            (click)="onAssignMtrChanged(meters)"
            [value]="option"
          >
            {{ option.meterId }}
          </mat-list-option>
        </mat-selection-list>

        <div class="row">
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-label class="label-input">CT type :</mat-label>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-form-field>
              <mat-select
                formControlName="ctTypeCtr"
                [(ngModel)]="selectedLoad.meter.ctMake"
              >
                <mat-option value="" disabled selected>CtType</mat-option>
                <mat-option *ngFor="let item of ctTypes" value="{{ item }}">{{
                  item
                }}</mat-option>
              </mat-select>
              <mat-error
                *ngIf="formdata.get('ctTypeCtr').hasError('required')"
                class="help-block"
                >This field is required.</mat-error
              >
            </mat-form-field>
          </div>

          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-label class="label-input">CT Rating:</mat-label>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-form-field>
              <mat-select
                formControlName="ratingCtr"
                [(ngModel)]="selectedLoad.meter.ctRatingPrimary"
              >
                <mat-option value="" disabled selected>CT Rating</mat-option>
                <mat-option *ngFor="let item of ratings" value="{{ item }}">{{
                  item
                }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-label class="label-input">CT Accuracy:</mat-label>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
            <mat-form-field>
              <mat-select
                formControlName="accuracyCtr"
                [(ngModel)]="selectedLoad.meter.ctAccuracy"
              >
                <mat-option value="" disabled selected>Assign</mat-option>
                <mat-option
                  *ngFor="let item of accuracies"
                  value="{{ item }}"
                  >{{ item }}</mat-option
                >
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div></div>
        <br />
        <button
          bciprimarybutton
          class="button-primary"
          type="button"
          id="submitbtn"
          [disabled]="
            formdata.get('assignMtrCtr').hasError('required') ||
            formdata.get('ctTypeCtr').hasError('required')
          "
          (click)="assingMeterToLoad()"
        >
          Submit
        </button>
      </form>
    </div>
  </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-footer>
  <button
    type="button"
    class="btn mat-raised-button pull-right alignClose"
    id="closebtn"
    (click)="close(false)"
  >
    Close
  </button>
</mat-dialog-footer>
